import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
// import Paper from "@material-ui/core/Paper";

import React from "react";

export default function ReceptTable(props) {
  // const ReportTable = (props) => {
  const { report } = props;
  return (
    <div>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>วันที่</TableCell>
              <TableCell>ใบเสร็จเลขที่</TableCell>
              <TableCell>ถึงใบเสร็จเลขที่</TableCell>
              <TableCell>จำนวนใบเสร็จที่ใช้</TableCell>
              <TableCell>จำนวนใบเสร็จที่ยกเลิก</TableCell>
              <TableCell>ยกเลิกใบเสร็จเลขที่</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {report.transaction.map((trans, key) => (
              <TableRow key={key}>
                <TableCell
                  className="td"
                  align="center"
                  style={{ verticalAlign: "top" }}
                >
                  {trans.bill_date}
                </TableCell>
                <TableCell
                  className="td"
                  align="center"
                  style={{ verticalAlign: "top" }}
                >
                  {trans.start_bill}
                </TableCell>
                <TableCell
                  className="td"
                  align="center"
                  style={{ verticalAlign: "top" }}
                >
                  {trans.end_bill}
                </TableCell>
                <TableCell
                  className="td"
                  align="center"
                  style={{ verticalAlign: "top" }}
                >
                  {trans.bill_count}
                </TableCell>
                <TableCell
                  className="td"
                  align="center"
                  style={{ verticalAlign: "top" }}
                >
                  {trans.canceled.length}
                </TableCell>
                <TableCell className="td" align="center">
                  {trans.canceled.map((cancel, key) => (
                    <div key={key} style={{ paddingBottom: "3px" }}>
                      {cancel}
                    </div>
                  ))}
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell className="td" align="center" colSpan={3}>
                <div style={{ fontWeight: 400, textAlign: "center" }}>รวม</div>
              </TableCell>
              <TableCell className="td" align="center">
                <div style={{ fontWeight: 400, textAlign: "center" }}>
                  {report.total_bill}
                </div>
              </TableCell>
              <TableCell className="td" align="center">
                <div style={{ fontWeight: 400, textAlign: "center" }}>
                  {report.total_cancel}
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
